import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "leitner-fab-root"
}
const _hoisted_2 = ["onKeydown"]
const _hoisted_3 = { class: "leitner-dialog__panel" }
const _hoisted_4 = { class: "leitner-dialog__field" }
const _hoisted_5 = { class: "leitner-dialog__field" }
const _hoisted_6 = { class: "leitner-dialog__field" }
const _hoisted_7 = { class: "leitner-dialog__row" }
const _hoisted_8 = { class: "leitner-dialog__field" }
const _hoisted_9 = { class: "leitner-dialog__field" }
const _hoisted_10 = {
  key: 0,
  class: "leitner-dialog__error",
  role: "alert"
}
const _hoisted_11 = {
  key: 1,
  class: "leitner-dialog__success",
  role: "status"
}
const _hoisted_12 = { class: "leitner-dialog__actions" }
const _hoisted_13 = ["disabled"]

import { computed, nextTick, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { createLeitnerCard } from "@/api/leitner";
import { useAuth } from "@/composables/useAuth";
import { handleError } from "@/services/errorHandler";
import { tokenStorage } from "@/api/client";


const __default__ = {
  name: "LeitnerAddWordFab",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const { isAuthenticated: authFlag } = useAuth();

const open = ref(false);
const submitting = ref(false);
const errorMessage = ref<string | null>(null);
const successMessage = ref<string | null>(null);
const wordInput = ref<HTMLInputElement | null>(null);

const form = reactive({
  word: "",
  definition: "",
  example: "",
  phonetic: "",
  part_of_speech: "",
});

const isAuthenticated = computed(
  () => authFlag.value || !!tokenStorage.getAccess()
);

const isPublicAuthPage = computed(() => route.meta.public === true);

const visible = computed(() => isAuthenticated.value && !isPublicAuthPage.value);

watch(
  () => open.value,
  async (isOpen) => {
    if (!isOpen) return;
    errorMessage.value = null;
    successMessage.value = null;
    await nextTick();
    wordInput.value?.focus();
  }
);

function resetForm() {
  form.word = "";
  form.definition = "";
  form.example = "";
  form.phonetic = "";
  form.part_of_speech = "";
}

function close() {
  open.value = false;
  submitting.value = false;
  errorMessage.value = null;
  successMessage.value = null;
  resetForm();
}

async function submit() {
  if (submitting.value) return;
  submitting.value = true;
  errorMessage.value = null;
  successMessage.value = null;
  try {
    await createLeitnerCard({
      word: form.word.trim(),
      definition: form.definition.trim(),
      example: form.example.trim() || null,
      phonetic: form.phonetic.trim() || null,
      part_of_speech: form.part_of_speech.trim() || null,
    });
    successMessage.value = `«${form.word.trim()}» به جعبه ۱ اضافه شد.`;
    resetForm();
    await nextTick();
    wordInput.value?.focus();
  } catch (e) {
    errorMessage.value = handleError(e, "LeitnerAddWord.submit");
  } finally {
    submitting.value = false;
  }
}

// Hide FAB on login/signup/forgot-password.
watch(
  isPublicAuthPage,
  (isPublic) => {
    if (isPublic) close();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "leitner-fab",
          "aria-label": "افزودن واژه به جعبه لایتنر",
          title: "لایتنر",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            width: "22",
            height: "22",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", {
              d: "M12 5v14M5 12h14",
              "stroke-linecap": "round"
            })
          ], -1),
          _createElementVNode("span", { class: "leitner-fab__label" }, "لایتنر", -1)
        ]))]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (open.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "leitner-dialog",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "leitner-add-title",
                onKeydown: _withKeys(_withModifiers(close, ["prevent"]), ["esc"])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "leitner-dialog__backdrop",
                  "aria-label": "بستن",
                  onClick: close
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("header", { class: "leitner-dialog__header" }, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                      _createElementVNode("p", { class: "leitner-dialog__eyebrow" }, "جعبه لایتنر"),
                      _createElementVNode("h2", {
                        id: "leitner-add-title",
                        class: "leitner-dialog__title"
                      }, "افزودن واژه جدید")
                    ], -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "leitner-dialog__close",
                      "aria-label": "بستن",
                      onClick: close
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        width: "18",
                        height: "18",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 6l12 12M18 6 6 18",
                          "stroke-linecap": "round"
                        })
                      ], -1)
                    ]))])
                  ]),
                  _createElementVNode("form", {
                    class: "leitner-dialog__form",
                    onSubmit: _withModifiers(submit, ["prevent"])
                  }, [
                    _createElementVNode("label", _hoisted_4, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                        _createTextVNode("واژه "),
                        _createElementVNode("em", null, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        ref_key: "wordInput",
                        ref: wordInput,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.word) = $event)),
                        type: "text",
                        maxlength: "120",
                        placeholder: "مثلاً accumulate",
                        required: "",
                        autocomplete: "off",
                        dir: "ltr"
                      }, null, 512), [
                        [_vModelText, form.word]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_5, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", null, [
                        _createTextVNode("معنی / تعریف "),
                        _createElementVNode("em", null, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.definition) = $event)),
                        rows: "3",
                        maxlength: "2000",
                        placeholder: "تعریف واژه را بنویس",
                        required: ""
                      }, null, 512), [
                        [_vModelText, form.definition]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_6, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "مثال (اختیاری)", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.example) = $event)),
                        rows: "2",
                        maxlength: "2000",
                        placeholder: "یک جمله نمونه",
                        dir: "ltr"
                      }, null, 512), [
                        [_vModelText, form.example]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "تلفظ (اختیاری)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.phonetic) = $event)),
                          type: "text",
                          maxlength: "120",
                          placeholder: "/əˈkjuːmjəleɪt/",
                          dir: "ltr"
                        }, null, 512), [
                          [_vModelText, form.phonetic]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_9, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "نقش دستوری", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.part_of_speech) = $event)),
                          type: "text",
                          maxlength: "40",
                          placeholder: "noun / verb / ...",
                          dir: "ltr"
                        }, null, 512), [
                          [_vModelText, form.part_of_speech]
                        ])
                      ])
                    ]),
                    (errorMessage.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errorMessage.value), 1))
                      : _createCommentVNode("", true),
                    (successMessage.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(successMessage.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "leitner-dialog__btn leitner-dialog__btn--ghost",
                        onClick: close
                      }, " انصراف "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "leitner-dialog__btn leitner-dialog__btn--primary",
                        disabled: submitting.value
                      }, _toDisplayString(submitting.value ? "در حال ذخیره..." : "افزودن به جعبه ۱"), 9, _hoisted_13)
                    ])
                  ], 32)
                ])
              ], 40, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      ]))
    : _createCommentVNode("", true)
}
}

})